import axios from '../axios'
// 物料表列表
export const getBaseMaterialPage = (data) => {
  return axios({
    url: '/api/sys/getBaseMaterialPage',
    method: 'post',
    data
  })
}
//物料表列表保存
export const saveBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/saveBaseMaterial',
    method: 'post',
    data
  })
}
// 物料表修改
export const updateBaseMaterial = (data) => {
  return axios({
    url: '/api/sys/updateBaseMaterial',
    method: 'post',
    data
  })
}
// 物料表删除
export const deleteBaseMaterials = (data) => {
  return axios({
    url: '/api/sys/deleteBaseMaterials',
    method: 'post',
    data
  })
}
// 物料分组维护列表
export const getBaseMaterialGroupPage = (data) => {
  return axios({
    url: '/api/sys/getBaseMaterialGroupPage',
    method: 'post',
    data
  })
}
// 物料分组维护列表删除
export const deleteBaseMaterialGroups = (data) => {
  return axios({
    url: '/api/sys/deleteBaseMaterialGroups',
    method: 'post',
    data
  })
}
// 物料分组维护列表修改
export const updateBaseMaterialGroup = (data) => {
  if (data.groupId) {
    return axios({
      url: '/api/sys/updateBaseMaterialGroup',
      method: 'post',
      data
    })
  } else {
    return axios({
      url: '/api/sys/saveBaseMaterialGroup',
      method: 'post',
      data
    })
  }
}


// 物料表成本列表
export const getBaseMaterialCostPage = (data) => {
  return axios({
    url: '/api/sys/base/getBaseMaterialCostPage',
    method: 'post',
    data
  })
}
//物料表成本列表保存
export const saveBaseMaterialCost = (data) => {
  return axios({
    url: '/api/sys/base/saveBaseMaterialCost',
    method: 'post',
    data
  })
}
// 物料成本表修改
export const updateBaseMaterialCost = (data) => {
  return axios({
    url: '/api/sys/base/updateBaseMaterialCost',
    method: 'post',
    data
  })
}
// 物料成本表删除
export const deleteBaseMaterialCosts = (data) => {
  return axios({
    url: '/api/sys/base/deleteBaseMaterialCosts',
    method: 'post',
    data
  })
}


// 物料库存表列表
export const getStkInventoryPage = (data) => {
  return axios({
    url: '/api/sys/stk/getStkInventoryPage',
    method: 'post',
    data
  })
}
// 物料库存明细表列表
export const getStkInventoryDetailPage = (data) => {
  return axios({
    url: '/api/sys/stk/getStkInventoryDetailPage',
    method: 'post',
    data
  })
}
// 物料库存表列表保存修改
export const saveStkInventory = (data) => {
  if (!data.id) {
    return axios({
      url: '/api/sys/stk/saveStkInventory',
      method: 'post',
      data
    })
  } else {
    return axios({
      url: '/api/sys/stk/updateStkInventory',
      method: 'post',
      data
    })
  }
}
// 物料库存表列表修改
export const updateStkInventory = (data) => {
  return axios({
    url: '/api/sys/stk/updateStkInventory',
    method: 'post',
    data
  })
}
// 物料库存表列表删除
export const deleteStkInventorys = (data) => {
  return axios({
    url: '/api/sys/stk/deleteStkInventorys',
    method: 'post',
    data
  })
}
// 获取物料规格
export const getMaterialSpecList = (data) => {
  return axios({
    url: '/api/sys/getMaterialSpecList',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Material.js